import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMagdeburg() {
  return (
    <CityPageTemplate
      city="Magdeburg"
      slug="magdeburg"
      intro="Magdeburg als Landeshauptstadt Sachsen-Anhalts – wir helfen Dir, staatliche Förderungen optimal zu nutzen."
      description="Unabhängige & digitale Finanzberatung für Magdeburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
